import { Icon } from '@/design-system/components/icons/Icon';
import { TextBody } from '@/design-system/components/typography';
import { Pressable, SxProp, View } from 'dripsy';
import { Moment } from 'moment-timezone';
import React from 'react';

interface DatePickerCallBackProps {
  dateProps: Moment | null;
  onClick: () => void;
  sx?: SxProp;
  placeholder?: string;
}

export const DatePickerCallBackComponent: React.FC<DatePickerCallBackProps> = ({ dateProps, sx, placeholder, onClick }) => {
  const { container, wrapper } = styles;

  return (
    <View sx={wrapper}>
      <View sx={{ ...container, ...sx }}>
        <TextBody>{dateProps ? dateProps.format('YYYY-MM-DD') : placeholder ?? ' - '}</TextBody>
        <Pressable onPress={onClick}>
          <Icon name="historyCalendar" />
        </Pressable>
      </View>
    </View>
  );
};

enum StyleName {
  wrapper = 'wrapper',
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  wrapper: {
    zIndex: 9999
  },
  container: {
    alignItems: 'center',
    overflow: 'hidden',
    flexDirection: 'row',
    width: '100%',
    height: '$12',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '$borderButton',
    justifyContent: 'space-between',
    px: '$4'
  }
};
